import axios from 'axios'
import humps from 'humps'

import { BACKEND_DOMAIN } from 'constants/support'

let REACT_APP_API_PREFIX
REACT_APP_API_PREFIX = `${BACKEND_DOMAIN}v1/`

const IGNORE_KEYS = ['_error', 'DOMESTIC', 'INTERNATIONAL', 'zh-CN', 'zh-TW']

const convertKeys = (key, convert) => {
  return IGNORE_KEYS.indexOf(key) !== -1 ? key : convert(key)
}

let sessionKey = null
let baseOptions = {
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  transformRequest: (data) => {
    return JSON.stringify(humps.decamelizeKeys(data, convertKeys))
  },
  transformResponse(data, headers) {
    return humps.camelizeKeys(data, convertKeys)
  },
}

export function setSessionKey(value) {
  sessionKey = value
}

const api = axios.create({
  ...baseOptions,
  baseURL: REACT_APP_API_PREFIX,
})

api.interceptors.request.use(function (config) {
  if (sessionKey) {
    config.headers['X-Session-Id'] = sessionKey
  }
  return config
})

export const noTransformApi = axios.create({
  baseURL: REACT_APP_API_PREFIX,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

const formOptions = {
  responseType: 'json',
  withCredentials: true,
  transformResponse(data) {
    return humps.camelizeKeys(data, convertKeys)
  },
}

export const formApi = axios.create({
  ...formOptions,
  baseURL: REACT_APP_API_PREFIX,
})

export default api
